import React, { useState, useEffect, useCallback } from 'react';
import { 
  Container, 
  CssBaseline, 
  Box, 
  Typography, 
  
  Divider,
  
  Alert,
  Snackbar,
  createTheme,
  ThemeProvider,
 
} from '@mui/material';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import Registration from './Registration';
import UserLookup from './UserLookup';
import BeanClaim from './BeanClaim';
import RewardsList from './RewardsList';
import { getRemainingBeans } from './api';

// Create a theme with coffee-inspired colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#077336', // Coffee brown
    },
    secondary: {
      main: '#A67B5B', // Lighter coffee
    },
    background: {
      default: '#F5F5F5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
  },
});

function ApiHome() {
  const [userEmail, setUserEmail] = useState(undefined);
  const [userPhone, setUserPhone] = useState(undefined);
  const [isRegistered, setIsRegistered] = useState(false);
  const [remainingBeans, setRemainingBeans] = useState(0);
  //const [ setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
    

   

    
   

  const fetchUserBeans = useCallback(async () => {
    try {
      
      const beansData = await getRemainingBeans(userEmail, userPhone);
      setRemainingBeans(beansData.remainingBeans || 0);
    } catch (err) {
      console.error('Error fetching beans:', err);
      setError('Failed to load your bean balance. Please try again.');
    } 
  }, [userEmail, userPhone]);
  
  useEffect(() => {
    if ((userEmail || userPhone) && isRegistered) {
      fetchUserBeans();
    }
  }, [userEmail, userPhone, isRegistered, refreshTrigger, fetchUserBeans]);

  const handleUserFound = (registered, email, phone) => {
    setUserEmail(email);
    setUserPhone(phone);
    setIsRegistered(registered);
    
    if (!registered) {
      setRemainingBeans(0);
    }
  };

  const handleRegistrationSuccess = (email, phone) => {
    setUserEmail(email);
    setUserPhone(phone);
    setIsRegistered(true);
    refreshData();
  };

  const refreshData = () => {
    setRefreshTrigger(prev => prev + 1);
  };
   
  

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
     
      
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{  paddingTop:10 }}>
          <Typography variant="h5" component="h1" gutterBottom align="center">
            Welcome to Koffie Rewards
          </Typography>
          <Typography variant="subtitle1" align="center" color="text.secondary" paragraph>
            Register, claim beans for your purchases, and redeem exciting rewards!
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2, mb: 1 }}>
        <LocalCafeIcon color="primary" sx={{ fontSize: 30, ml: 1 }} />
        <Typography variant="body2" component="span" sx={{ ml: 1 }}>
          {isRegistered ? 'You are a registered user!' : 'Register or Login?'}
        </Typography>
        {isRegistered && (userEmail || userPhone) && (
            <Typography variant="body2">
              {userEmail || userPhone} | {remainingBeans} Beans
            </Typography>
          )}
         
        </Box>
          
              <Registration onRegistrationSuccess={handleRegistrationSuccess} />
            
              
        </Box>
        
         
        {!isRegistered ? (
          <>
            <UserLookup onUserFound={handleUserFound} />
            
            {(userEmail || userPhone) && !isRegistered && (
              <Registration onRegistrationSuccess={handleRegistrationSuccess} />
            )}
          </>
        ) : (
          <Alert severity="success" sx={{ mb: 4 }}>
            You're registered with {userEmail || userPhone}! You have {remainingBeans} beans available.
          </Alert>
        )}
        
        <Divider sx={{ my: 4 }} />
        
        <BeanClaim 
          userEmail={userEmail}
          userPhone={userPhone}
          isRegistered={isRegistered}
          onClaimSuccess={refreshData}
        />
        
        <Divider sx={{ my: 4 }} />
        
        <RewardsList 
          userEmail={userEmail}
          userPhone={userPhone}
          isRegistered={isRegistered}
          remainingBeans={remainingBeans}
          onRedeemSuccess={refreshData}
        />
        
        <Snackbar 
          open={error !== null} 
          autoHideDuration={6000} 
          onClose={() => setError(null)}
        >
          <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Snackbar>
      </Container>
    </ThemeProvider>
  );
}

export default ApiHome;
